export const SET_NOTE_TYPE_FILTER = 'noteTypeFilters/SET_NOTE_TYPE_FILTER';
export const RESET_NOTE_TYPE_FILTERS = 'noteTypeFilters/RESET_NOTE_TYPE_FILTERS';
